export class LocationQuery {
  constructor () {
    this.text = undefined;
    this.current = undefined;
    this.pageSize = undefined;
  }
}
